import { Item } from './List.components.styles';

import type { ItemProps } from './List.components.d';

const ItemBase = ({
  alternateColor,
  children,
  footer,
  header,
  padding = true,
  ...props
}: ItemProps) => (
  <Item
    data-alternate={alternateColor}
    data-footer={footer}
    data-header={header}
    data-padding={padding}
    {...props}
  >
    {children}
  </Item>
);

export default ItemBase;
